<template>
  <div class="wrap">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true"
          >绑定老人</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column prop="cusName" label="姓名"> </el-table-column>
      <el-table-column prop="idCard" label="身份证" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="relation" label="与老人关系" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="icon" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="service(scope.row)"
            >服务记录</el-button
          >
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" @click="editHandle(scope.row)">编辑</el-button>
          <!--                    <el-divider direction="vertical"></el-divider>-->
          <!--                    <el-button type="text" @click="changeMan(scope.row)"-->
          <!--                    >换绑老人</el-button-->
          <!--                    >-->
          <el-divider direction="vertical"></el-divider>
          <template>
            <el-popconfirm
              width="250"
              height="300"
              title="这是一段内容确定删除吗？"
              @confirm="delHandle(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="80rem"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        :inline="true"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="姓名" prop="customerName" label-width="100px">
          <el-input
            v-model="editForm.customerName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard" label-width="100px">
          <el-input v-model="editForm.idcard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" label-width="100px">
          <el-input v-model="editForm.phone" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >立即搜索</el-button
          >
          <el-button @click="resetForm('editForm')">重置</el-button>
        </el-form-item>
        <template>
          <el-table :data="oldManData" style="width: 100%">
            <el-table-column prop="customerName" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="180">
            </el-table-column>
            <el-table-column prop="idcard" label="身份证" width="180">
            </el-table-column>
            <el-table-column prop="address" label="地址"> </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >绑定老人</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="permDialogVisible" width="600px">
      <el-form :model="permForm">
        <el-form-item label="与老人关系" prop="relation" label-width="100px">
          <el-input v-model="permForm.relation" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="permDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateForm('permForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="serviceFlag"
      width="80rem"
      :before-close="handleClose"
    >
        <div class="wrap">
        <div style="width:100%;margin:20px 0;">
            <el-form ref="form" :model="sizeForm" label-width="100px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="服务类型">
                            <el-select v-model="sizeForm.type" placeholder="全部">
                                <el-option label="居家服务" value=1></el-option>
                                <el-option label="机构" value=2></el-option>
                                <el-option label="适老化改造" value=3></el-option>
                                <el-option label="家庭床位" value=4></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                          <el-form-item size="large">
                    <el-button type="primary" @click="onSubmit('sizeForm')">立即查询</el-button>
                </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </div>
        <el-divider></el-divider>
        <div style="width:80%;margin:0 10%;">
            <el-table
                    :data="serviceData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="ordernum"
                        label="工单号"
                        width="180">
                </el-table-column>
                <el-table-column prop="type" label="类型" width="140">
                    <template slot-scope="scope">
                        <el-tag size="small" type="success"
                        >居家服务</el-tag
                        >
<!--                        <el-tag size="small" v-else-if="scope.row.type === '2'" type="success"-->
<!--                        >机构养老</el-tag-->
<!--                        >-->
<!--                        <el-tag size="small" v-else-if="scope.row.type === '3'" type="success"-->
<!--                        >适老化改造</el-tag-->
<!--                        >-->
<!--                        <el-tag size="small" v-else-if="scope.row.type === '4'" type="success"-->
<!--                        >家庭床位</el-tag-->
<!--                        >-->
                    </template>
                </el-table-column>
                <el-table-column
                        prop="servePersonName"
                        label="服务人员"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="servePersonPhone"
                        label="服务人员电话">
                </el-table-column>
                <el-table-column
                        prop="customerphone"
                        label="联系人电话">
                </el-table-column>
                <el-table-column
                        prop="startTime"
                        label="服务开始时间">
                </el-table-column>
            </el-table>
        </div>
    </div>
    </el-dialog>
  </div>
</template>

<script>
// import qs from "qs";

export default {
  name: "customer",
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,

      total: 0,
      size: 10,
      current: 1,

      dialogVisible: false,
      serviceFlag: false,
      editForm: {},
       sizeForm: {},
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      tableData: [],
      oldManData: [],
      editFormRules: {
        customerName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        idcard: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
            message: "请输入正确的身份证",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
      },

      multipleSelection: [],

      permDialogVisible: false,
      permForm: {},
      defaultProps: {
        children: "children",
        label: "name",
      },
      oldManList:[],
      serviceData:[],
      permTreeData: [],
      province: [],
      city: [],
      area: [],
      flag: true,
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.getRoleList();
    this.getprovince();
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getRoleList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = true;
      this.editForm = {};
    },
    handleClose() {
      this.serviceFlag = false;
      this.resetForm("editForm");
      this.dialogVisible = false;
      this.serviceFlag = false;
    },

    getRoleList() {
      const uid = this.userInfo.id;
      this.$axios
        .get("/gw/user/customer/list/" + uid, {
          params: {
            // customerName: this.searchForm.name,
            // customerName: this.current,
            // phone: this.size,
            // state:''
          },
        })
        .then((res) => {
          this.tableData = res.data.data.records;
          this.size = res.data.data.size;
          this.current = res.data.data.current;
          this.total = res.data.data.total;
        });
    },

    getprovince() {
      this.$axios.get("/gw/address/child/0").then((res) => {
        if (res.status == 200) {
          this.province = res.data.data;
        }
      });
    },

    getcity(pid) {
      this.$axios.get("/gw/address/child/" + pid).then((res) => {
        if (res.status == 200) {
          this.city = res.data.data;
        }
      });
    },

    getarea(pid) {
      this.$axios.get("/gw/address/child/" + pid).then((res) => {
        if (res.status == 200) {
          this.area = res.data.data;
        }
      });
    },

    submitForm(formName) {
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/wx/customer/new/list", this.editForm)
            .then((res) => {
              if (res.status == 200) {
                this.oldManData = res.data.data.records;
              }
              // this.dialogVisible = false;
              // this.resetForm(formName);
            });
        } else {
          return false;
        }
      });
    },
    handleClick(row) {
      if (!this.flag) {
        var itemUrl = "/gw/user/customer/update";
        row.id = this.editForm.id;
      } else {
        var itemUrl = "/gw/user/customer/save";
      }
      this.$prompt("请输入与老人关系", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        row.createId = this.userInfo.id;
        row.createName = this.userInfo.username;
        row.relation = value;
        row.cusId = row.id;
        row.userId = this.userInfo.id;
        row.username = this.userInfo.username;
        row.cusName = row.customerName;
        this.$axios.post(itemUrl, row).then((res) => {
          if (res.status == 200) {
            this.dialogVisible = false;
            location.reload();
            // this.resetForm(formName);
          }
        });
      });
    },
    updateForm(formName) {
      this.$axios
        .post("/gw/user/customer/update", this.permForm)
        .then((res) => {
          if (res.status == 200) {
            this.permDialogVisible = false;
            this.resetForm(this.permForm);
          }
        });
    },
    editHandle(res) {
      this.permForm = res;
      this.permDialogVisible = true;
    },
    service(row) {
      this.serviceFlag = true;
      this.getOrder(row)
      this.sizeForm.idCard = row.idCard;
    },
    init() {
      const uid = this.userInfo.id;
      this.$axios
        .get("/gw/user/customer/list/1/" + uid, {
          params: {
            // customerName: this.searchForm.name,
            // customerName: this.current,
            // phone: this.size,
            // state:''
          },
        })
        .then((res) => {
          this.oldManList = res.data.data.records;
        });
    },
    getOrder(row){
        if(typeof row.type == 'undefined'){
            row.type = 1;
        }
        console.log(row)
         this.$axios
        .get("/wx/service/order/list/"+row.idCard+"/"+row.type, {
          params: {
            // customerName: this.searchForm.name,
            // customerName: this.current,
            // phone: this.size,
            // state:''
          },
        })
        .then((res) => {

          this.serviceData = res.data.data.records;
            // this.serviceData.type=row.type
        });
    },
    onSubmit(){
        this.$axios
        .get("/wx/service/order/list/"+this.sizeForm.idCard+"/"+this.sizeForm.type, {
          params: {
            // customerName: this.searchForm.name,
            // customerName: this.current,
            // phone: this.size,
            // state:''
          },
        })
        .then((res) => {
          this.serviceData = res.data.data.records;
        });
    },
    changeMan(res) {
      this.editForm = res;
      this.flag = false;
      this.dialogVisible = true;
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }
      this.$axios.post("/gw/user/customer/delete", ids).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {
            this.getRoleList();
          },
        });
      });
    },
    permHandle(id) {
      this.permDialogVisible = true;

      this.$axios.get("/gw/sys/role/info/" + id).then((res) => {
        this.$refs.permTree.setCheckedKeys(res.data.data.menuIds);
        this.permForm = res.data.data;
      });
    },

    submitPermFormHandle(formName) {
      var menuIds = this.$refs.permTree.getCheckedKeys();

      this.$axios
        .post("/gw/sys/role/perm/" + this.permForm.id, menuIds)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.getRoleList();
              this.$router.go(0);
            },
          });
          this.permDialogVisible = false;
          this.resetForm(formName);
        });
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 1.875rem /* 30px -> 1.875rem */ auto;
}
.el-pagination {
  float: right;
  margin-top: 1.375rem /* 22px -> 1.375rem */;
}
</style>
